document.addEventListener("DOMContentLoaded", () => {
  // --- Swiper init for custom_carousel (always) ---
  // peek mode changes the config; without peek, standard thumbs carousel is used
  const swiperGallery = document.querySelector(".product-single__gallery.custom-slider");

  if (swiperGallery) {
    const isPeek = swiperGallery.dataset.mobilePeek === "true";

    const swiperSliderThumb = new Swiper(".thumbnails-product-img", {
      slidesPerView: 10,
      spaceBetween: 12,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          direction: "vertical",
        },
      },
    });

    if (isPeek) {
      new Swiper(".main-product-img", {
        slidesPerView: "auto",
        spaceBetween: 10,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: swiperSliderThumb,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
          },
        },
      });
    } else {
      new Swiper(".main-product-img", {
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
          swiper: swiperSliderThumb,
        },
      });
    }
  }

  // --- Flickity re-init for standard layouts + mobile peek ---
  // Only on mobile, only for non-custom_carousel galleries with data-mobile-peek
  const flickityPeekGallery = document.querySelector(
    ".custom-slider--mobile-peek:not(.custom-slider)[data-mobile-peek='true']"
  );

  if (flickityPeekGallery && window.innerWidth < 768) {
    const slider = flickityPeekGallery.querySelector("[data-product-single-media-slider]");

    if (slider) {
      // Flickity lives inside themeVendor (vendor.js), not on window.Flickity
      const initPeekFlickity = (attempts) => {
        const FlickityLib = window.themeVendor && window.themeVendor.Flickity;
        if (!FlickityLib) {
          if (attempts < 15) setTimeout(() => initPeekFlickity(attempts + 1), 100);
          return;
        }

        const flkty = FlickityLib.data(slider);
        if (!flkty) {
          if (attempts < 15) setTimeout(() => initPeekFlickity(attempts + 1), 100);
          return;
        }

        flkty.destroy();

        new FlickityLib(slider, {
          cellAlign: "left",
          wrapAround: false,
          contain: false,
          pageDots: true,
          prevNextButtons: false,
          adaptiveHeight: false,
          on: {
            settle: () => {
              // Preserve theme's media visibility toggling
              const mediaWrappers = slider.querySelectorAll("[data-product-single-media-wrapper]");
              const selected = slider.querySelector(
                ".is-selected [data-product-single-media-wrapper]"
              );
              mediaWrappers.forEach((el) => {
                el.classList.toggle("media--hidden", el !== selected);
              });
            },
          },
        });
      };

      initPeekFlickity(0);
    }
  }

  // --- Sticky checkout button ---
  const trigger = document.querySelector(".sticky-trigger");
  const stickyBtn = document.querySelector(".sticky-product-buttons");

  if (!trigger || !stickyBtn) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyBtn.classList.remove("show-buttons");
        } else {
          stickyBtn.classList.add("show-buttons");
        }
      });
    },
    { root: null, threshold: 0.5 }
  );

  observer.observe(trigger);
});
